/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 葡萄牙语 国际化语言文件
 */
// 葡萄牙语.js
export default {
  centerAgent: {
    subagency: "Subagência",
    search: "Pesquisar",
    subagencyIncome: "Renda da Subagência",
    last29Days: "Últimos 29 Dias",
    excludingToday: "Excluindo Hoje",
    commission: "Comissão",
    last30Days: "Dados dos Últimos 30 Dias",
    rank: "Classificação",
    hostNumber: "Número de Anfitriões",
    recent30Days: "Renda do Anfitrião nos Últimos 30 Dias",
    commissionRate: "Taxa de Comissão",
    myCommission: "Minha Comissão",
    remove: "Remover",
    thisAction:
      "Esta ação removerá {hostoragent} {hostname} da sua equipe. Você confirma que deseja prosseguir?",
    dashboard: "Painel",
    information: "Informação",
    dataCenter: "Centro de Dados",
    hostList: "Lista de Anfitriões",
    bdList: "Lista de BD",
    agencyList: "Lista de Agências",
    myRight: "Meus Direitos",
    numberOf: "Número de Agências",
    inviteAgency: "Convidar Agência",
    numberOfHost: "Número de Anfitriões",
    inviteHost: "Convidar anfitrião",
    inviteHostlinkcopied: "Link do convite copiado",
    tipsShare: "Dica: Compartilhe o link do convite com seus amigos.",
    thisMonthD: "Dados Deste Mês",
    formDay1: "De day1 a day2",
    hostGift: "Pontos de Presente do Anfitrião",
    agentCommission: "Comissão de Agente",
    currentLevel: "Nível Atual",
    commissionRateOf: "Taxa de comissão da receita dos agentes",
    baseSalary: "Salário Base",
    stillNeed: "Ainda preciso",
    toReach: "para alcançar",
    reachedthe: "Tarefa de Publicidade",
    advertisementTask: "Visão Geral dos Dados",
    dataOverview: "Visão Geral de Dados",
    today: "Hoje",
    hostPoint: "Pontos de Hoste",
    agentsPoints: "Renda de Pontos de Agente",
    thisMonth: "Este Mês",
    month: "Mês",
    lastMonth: "Mês Passado",
    bdNumber: "Número de BD",
    hostIncome: "Renda do Hoste",
    todayIncome: "Renda de Hoje",
    past30Days: "Últimos 30 Dias",
    host: "Anfitrião",
    country: "País",
    level7: "Nível / Receita de 7 Dias",
    pointIncome: "Receita de Pontos",
    liveDuration: "Duração ao vivo",
    joinTime: "Hora de Entrada",
    state: "Estado",
    operation: "Operação",
    bd: "BD",
    totalHosts: "Receita Total do Hoste",
    totalAgents: "Receita Total do Agente",
    agent: "Agente",
    agentLevel: "Nível do Agente / Taxa de Comissão",
    commissionIncome: "Receita de Comissão",
    showDirect: "Mostrar apenas agentes diretos. Excluindo dados de hoje",
    excludingTodayData: "Excluindo dados de hoje",
    packages: "Pacotes",
    contents: "Conteúdos",
    balance: "Saldo",
    release: "Liberar",
    issue: "Emitir",
    createBd: "Criar BD",
    times: "vezes",
    authorizeCs: "Autorizar CS",
    giftTo: "Presentear ao Usuário",
    bdCreation: "Limite de Criação de BD Restante",
    csAuthorization: "Quota de Autorização CS Restante",
    giftName: "Nome do Presente",
    giftContents: "Conteúdo do Presente",
    check: "Verificar",
    cancel: "Cancelar",
    tip: "Gorjeta",
    recipientsVip:
      "O nível de VIP do destinatário excede o limite do pacote de presente. Os benefícios de VIP deste presente serão desativados. Tem certeza de que deseja continuar?",
    confirm: "Confirmar",
    authorize: "Autorizar",
    inviteBy: "Convidar por ID do Usuário",
    invite: "Convidar",
    inviteLink: "Link de Convite",
    copy: "Copiar",
    success: "Sucesso",
    pleaseCheck: "Por favor verifique o ID do usuário",
    totalGift:
      "Renda total de presentes de todos os hosts (excluindo recompensas da plataforma como rankings, tarefas, etc.), incluindo a renda de presentes das sub-agências.",
    totalAgentsCom:
      "Comissão total dos agentes da renda de seus hosts, incluindo a comissão dos subagentes.",
    allAgent: "Todos os Agentes",
    directAgent: "Agente Direto",
    indirectAgent: "Agente Indireto",
    newUpgraded: "Novo Agente Atualizado",
    newS: "Novos Agentes S",
    newB: "Novos Agentes B",
    newC: "Novos Agentes C",
    expectedReward: "Recompensa Esperada",
    newA: "Novos Agentes A",
    agencyLevel: "Nível da Agência",
    nickname: "Apelido",
    editNicknameTip:
      "Você pode alterar o nome da sua agência gratuitamente uma vez por mês",
    enterNewNickname: "Por favor, insira um novo apelido",
    nicknameUpdateSuccess: "Apelido atualizado com sucesso",
    cannotEditNickname: "Não É Possível Editar Apelido",
    cannotEditTip:
      "Você só pode editar seu apelido uma vez gratuitamente. Por favor, entre em contato com o suporte ao cliente para modificar seu apelido.",
    alreadyChangedTip:
      "Você já mudou o nome da sua agência este mês. Mudanças adicionais custam 8.000 moedas.",
    payAndSave: "Pagar e salvar",
    upgradeDate: "Data de Upgrade",
    bdPolicy: "Política de BD",
    agencyDetail: "Detalhes da Agência",
    agency: "Agência",
    hostCommission: "Comissão de Host",
    last6Days: "Últimos 6 Dias",
    giftIncome: "Renda de Presente",
    mins: "mins",
    agencyCenter: "Centro de Agência",
    myIncome: "Minha Renda Hoje",
    totalHost: "Pontos de Host Totais",
    overview: "Visão Geral",
    hostPoints: "Pontos de Host",
    myHosts: "Meus Pontos de Host",
    subagentHost: "Pontos de Host do Subagente",
    subagencyNumber: "Número de Subagências",
    otherIncome: "Outras Rendas",
    contactAdmin: "Contatar o Admin",
    whatsapp: "WhatsApp",
    bdCenter: "Centro BD",
    copySuccess: "Cópia Bem-sucedida",
    pleaseInput: "Por favor, insira o valor da recarga, mínimo 10",
    agencyPolicy: "Política de Agência",
    agencyCommission: "Comissão de Agência",
    agencyCommission2:
      "Comissão de Agência = Taxa de Comissão × Renda Total de Presentes de Todos os Hosts (excluindo recompensas da plataforma como rankings, tarefas, etc.)",
    excludingPlatform:
      "(excluindo recompensas da plataforma como rankings, tarefas, etc.)",
    agencyCommissionCalculation: "Cálculo da Comissão de Agência",
    level: "Nível",
    pointsTarget: "Meta de Pontos (Últimos 30 Dias)",
    points10000: "10,000 Pontos = 1 USD (M= milhão)",
    note1:
      "Nota 1: Renda Válida Total = Sua renda de agência + Renda de cada nível de suas subagências",
    note2:
      "Nota 2: As comissões de agência serão creditadas em tempo real quando o host receber um presente.",
    note3:
      "Nota 3: O valor mínimo de saque é de 10 USD, e os saques devem ser feitos em múltiplos de 10 (por exemplo: 10 USD, 20 USD, 30 USD).",
    subagencycommission: "Comissão de Subagência",
    theMain:
      "A agência principal pode ganhar comissões da renda de cada nível de subagências (T1, T2, T3, T4, ... Tn), com uma taxa de comissão máxima de 16%.",
    forExample: "Por exemplo:",
    agencyA: "A Agência A convida a Agência B e a Agência C.",
    agencyB: "A Agência B convida a Agência D e a Agência E.",
    agencyC: "A Agência C convida a Agência F.",
    noteFigures:
      "(Nota: os números entre parênteses representam a renda dos hosts sob cada agência).",
    thusWe:
      "Assim, podemos calcular a Renda Válida Total e a Taxa de Comissão das agências da Agência A à Agência F.",
    totalValid:
      "Renda Válida Total = Renda da Sua Agência + Renda de Cada Nível de Subagência",
    aTotal:
      "A Renda Válida Total = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (taxa de comissão de 20%)",
    bTotal:
      "B Renda Válida Total = B + D + E = 20M + 20M + 30M = 70M (taxa de comissão de 16%)",
    cTotal:
      "C Renda Válida Total = C + F = 70M + 80M =150M (taxa de comissão de 20%)",
    dTotal: "D Renda Válida Total =20M (taxa de comissão de 12%)",
    eTotal: "E Renda Válida Total =30M (taxa de comissão de 12%)",
    fTotal: "F Renda Válida Total =80M (taxa de comissão de 16%)",
    subagencyCommission:
      "Comissão de Subagência = (Taxa de comissão da agência principal - Taxa de comissão da subagência) × Renda Válida Total da subagência",
    agencyAC: "Comissão da Agência {A} da Agência {B}",
    thereforeAgency: "Portanto, comissão total da Agência {A} das subagências",
    sinceAgency:
      "Como as Agências D, E e F não têm subagências, elas não podem ganhar comissões de subagência.",
    seniorPolicy: "Política Sênior",
    nomore: "Sem Mais Dados",
    active: "Ativo",
    disabled: "Desativado",
    deleted: "Excluído",
    lastLogintime: "Último Horário de Login",
    onmic: "No Micro Hoje",
  },
  sellerCoin: {
    detailsOf: "Detalhes do Saque",
    fundsSent: "Fundos Enviados",
    transfer: "Transferência",
    totalIncome: "Renda Total",
    orderIncome: "Renda de Pedido",
    estimatedReward: "Recompensa Estimada",
    amount: "Quantidade",
    applicantId: "ID do Requerente",
    applicantName: "Nome do Requerente",
    orderId: "ID do Pedido",
    uploadScreenshot: "Carregar Captura de Tela",
    ensureWithdrawal:
      "Certifique-se de que o saque foi bem-sucedido, então carregue a captura de ecrã e clique no botão abaixo para notificar o requerente.",
    remain: "Restante",
    pleasePay:
      "Pague imediatamente e carregue o recibo. Se exceder o tempo limite, a qualificação de pagamento do pedido será cancelada.",
    youCan: "Você pode ganhar até 5.000 pontos de convite por dia.",
    pleaseComplete: "Por favor, conclua o saque em tempo hábito ",
    unableTo: "Incapaz de Pagar, Recusar",
    notifyThe: "Notificar o Requerente",
    youCanGet:
      "Você pode ganhar 1% a 3% de bônus extra se lidar com os pedidos em tempo hábil.",
    ifYou:
      "Se você lidar com os pedidos em 30 minutos, pode obter 3% de bônus.",
    egThe:
      "Por exemplo: Um pedido no valor de 90000 pontos, você o processa em 30 minutos, pode obter 3% de bônus, que é 90000 × 3% = 2700 pontos.",
    gotIt: "Entendi",
    pleaseUpload: "Por favor, carregue a imagem",
    detail: "Detalhe",
    balance: "Balance",
    exchange: "Trocar",
    all: "Todos",
    recharge: "Recarregar",
    official: "Oficial",
    exchangeDetail: "Detalhe da Troca",
    coinSeller: "Vendedor de Moedas",
    levelUp: "Subir de Nível",
    currentLevel: "Nível Atual",
    myBalance: "Meu Saldo",
    details: "Detalhes",
    paymentMethod: "Método de pagamento",
    myOrder: "Meu Pedido",
    paymentMenthod: "Método de Pagamento",
    acceptingOrders: "Aceitando Pedidos",
    unavailable: "Indisponível",
    greetingMessage: "Configurações de Mensagem de Saudação",
    serviceUnavailable: "Serviço Indisponível",
    thisFeature:
      "Este recurso está temporariamente bloqueado. Entre em contato com o suporte ao cliente para obter assistência.",
    editMessage: "Editar Mensagem",
    customizeYour:
      "Personalize sua mensagem de saudação. Você pode incluir informações úteis sobre como recarregar moedas.",
    theMessage:
      "A mensagem será enviada automaticamente quando um novo usuário iniciar um chat privado com você",
    save: "Salvar",
    pleaseEnterMessge: "Por favor, insira sua mensagem de saudação",
    salesMethod: "Método de Vendas",
    user: "Usuário",
    coinseller: "Vendedor de Moedas",
    userId: "ID do usuário",
    check: "Verificar",
    coinAmount: "Quantidade de Moedas",
    pleaseEnter: "Por favor, insira um múltiplo de 1",
    enterAt: "Insira pelo menos 100, em múltiplos de 1",
    transferDetails: "Detalhes da Transferência",
    recommendSeller: "Recomendar Vendedor",
    recent30Day: "Vendas de Moedas dos Últimos 30 Dias",
    whatsapp: "WhatsApp",
    chat: "Bate-papo",
    yourCountry:
      "Seu país atualmente não tem vendedores de moedas disponíveis.",
    pleaseContact: "Por favor, entre em contato com o suporte ao cliente.",
    customerSupport: "suporte ao cliente",
    contact: "Contato",
    customRecharge: "Recarga Personalizada",
    rechargeDetails: "Detalhes da Recarga",
    myPoints: "Meus Pontos",
    todayRemaining: "Cota restante hoje",
    customExchange: "Troca Personalizada",
    exchangeDetails: "Detalhes da Troca",
    rechargeRules: "Regras de Recarga",
    sellerLevel: "Nível do Vendedor",
    proportion: "Proporção",
    levelRequirement: "Requisito de Nível",
    beginner: "Iniciante",
    singleRecharge: "Recarga única",
    standard: "Padrão",
    senior: "Sênior",
    exchangeRules: "Regras de Troca",
    note: "Note",
    seniorCoin:
      "O Vendedor Sênior pode trocar até {point} pontos diariamente na taxa completa. Após {point}:",
    beginnerSeller: "Vendedor Iniciante",
    standardSeller: "Vendedor Padrão",
    seniorSeller: "Vendedor Sênior",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2: "Por favor, insira o valor da recarga, múltiplos de 100K",
    confirmation: "Confirmação",
    userName: "Nome de Usuário",
    theUser: "O usuário foi colocado na lista negra",
    enterAmount: "Inserir valor",
    pleaseInput3: "Por favor, insira o valor",
    theAmount: "O valor deve ser um múltiplo de 100000",
    pleaseInput4: "Por favor, insira ou selecione o valor",
    pleaseSelect: "Por favor, selecione o método de vendas",
    pleaseInput5: "Por favor, insira o ID do usuário",
    atLeast: "Pelo menos 100K moedas para transferir~",
    pleaseSelect2: "Por favor, selecione o método de pagamento",
    minimum: "mínimo",
    theAmount3: "O valor deve ser um múltiplo de 1",
    lessThan: "menor ou igual a 100000",
    orders: "Pedidos",
    applicant: "Requerente",
    method: "Método",
    withdrawTime: "Tempo de Saque",
    viewDetail: "Ver Detalhe",
    toBe: "A ser confirmado",
    toBePaid: "A ser pago",
    toBeCompleted: "A ser concluído",
    completed: "Concluído",
    abnormal: "Anormal",
    refused: "Refused",
    confirmationTimeout: "Tempo esgotado de confirmação",
    paymentTimeout: "Tempo esgotado de pagamento",
    binance: "Binance",
    scanThe: "Digitalize o código QR para pagar",
    quantity: "Quantidade",
    orderAmount: "Valor do pedido",
    date: "Data",
    payNow: "Pagar Agora",
    payment: "Pagamento",
    pleasePay2: "Por favor, pague da seguinte forma",
    chainName: "Nome da Cadeia",
    contractAddress: "Endereço do Contrato",
    theAbove: "O endereço acima é válido apenas para esta recarga",
    copy: "Copy",
    notice: "Aviso",
    pleaseTransfer:
      "Por favor, transfira um Extra 1 USDT para cobrir a taxa da Binance. A falha em fazê-lo pode atrasar sua recarga de moedas.",
    paymentsMust:
      "Os pagamentos devem ser concluídos em 0,5 hora, ou a plataforma não será responsável por quaisquer problemas.",
    add: "Adicionar",
    confirmTo: "Confirmar para excluir este método de pagamento",
    countryCurrency: "País e Tipo de Moeda",
    selectPayment: "Selecione o método de pagamento que você pode remeter",
    coinsSeller: "Regras do Vendedor de Moedas",
    standrd: "Padrão",
    salesMethods: "Métodos de Vendas",
    coinsellerRules: "Regras do CoinSeller",
    whenApplying:
      "Ao solicitar um upgrade para o status de vendedor de moedas, não há requisitos de depósito, apenas precisa de 1 recarga para atualizar o nível do vendedor de moedas. Se você optar por renunciar à sua posição como vendedor de moedas, sua função atual de vendedor de moedas expirará",
    youCanReplenish:
      "Você pode reabastecer sua conta diretamente com USDT, Epay ou através de outro vendedor de moedas",
    fraudulentActivities:
      "Atividades fraudulentas são estritamente proibidas dentro da plataforma Hala.",
    anyViolations:
      "Quaisquer violações resultarão no encerramento da conta do vendedor de moedas",
    allRights: "Todos os direitos reservados por Hala.",
    transferDetail: "Detalhe da Transferência",
  },
  centerHost: {
    baseSalary: "Salário Base",
    invitation: "Convite",
    tasks: "Tarefas",
    other: "Outro",
    consume: "Consumir",
    giftIncome: "Gift Income",
    received: "Recebido",
    from: "de",
    luckyGift: "Presente de sorte",
    hostCenter: "Centro de Anfitrião",
    noAgent: "Sem agente",
    last7: "Últimos 7 dias",
    hourlyIncome: "Renda horária",
    toReach: "to reach",
    rules: "Regras",
    pointsOverview: "Visão Geral dos Pontos",
    totalIncome: "Renda Total",
    gifts: "presentes",
    workDetail: "Detalhe do Trabalho",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "Registro de hoje ao vivo",
    dailyStatistics: "Estatísticas Diárias",
    startTime: "Hora de início",
    endTime: "Hora de término",
    duration: "Duração",
    points: "Pontos",
    date: "Date",
    giftPoints: "Pontos de presente",
    removeBinding: "Remover Vinculação",
    thisAction2:
      "Esta ação irá desvincular você de {agentName}. Por favor, confirme se deseja prosseguir com o desvinculamento",
  },
  bombRule: {
    afterThe:
      "Depois que o valor de detonação na sala atingir a certa quantia, a bomba de presente aparecerá na sala",
    oneCoins: "1 moedas recebidas na sala = 1 valor de detonação",
    itWill:
      "Ele explodirá automaticamente após atender aos requisitos, e o proprietário da sala receberá recompensas correspondentes em moedas de ouro",
  },
  descriptionLevel: {
    wealth: "Riqueza",
    charm: "Charme",
    wealthValue: "Valor da Riqueza",
    charmValue: "Valor do Charme",
    needTo: "Precisa",
    send: "enviar",
    receive: "receber",
    forThe: "para a atualização",
    theRich: "O nível Rico é contado pelas moedas que você recarregou",
    theCharm:
      "O nível de Charme é calculado com base no número de moedas que você recebe",
    LevelLabel: "Rótulo de Nível",
    level: "Level",
    levelLogo: "Logotipo do Nível",
  },
  gameRank: {
    gameRank: "Classificação do Jogo",
    rules: "Rules",
    thisWeek: "Esta Semana",
    lastWeek: "Semana Passada",
    agentGaming: "Classificação de Receita de Jogos de Agente",
    rankingRewards: "Recompensas de Classificação",
    rankingIs:
      "A classificação é baseada no volume total de apostas dos usuários na sala do agente e suas sub-salas.",
    hostRoom: "Classificação de Receita da Sala do Anfitrião",
    rankingIs2:
      "A classificação é baseada na receita total de jogos gerada na sala do anfitrião",
    notes: "Observações",
    eventDuration:
      "Duração do evento: Cada semana civil. As recompensas são distribuídas apenas se",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves:
      "Hala reserva-se o direito de interpretação final deste evento",
    rewardsDetail: "Detalhe das Recompensas",
    decorationsPreview: "Visualização de Decorações",
  },
  gameLegacyHall: {
    surpriseLucky: "Bolsa da Sorte Surpresa",
    dailyPlayers:
      "Os jogadores diários podem abrir uma Bolsa da Sorte no dia seguinte para moedas aleatórias",
    eventRule: "Regra do Evento",
    usersSpending:
      "Os gastos dos usuários em jogos de evento contarão para sua pontuação de classificação",
    thePlatform:
      "A plataforma girará os jogos de evento a cada 4 horas, com 4 jogos diferentes em cada rotação",
    theTop:
      "Os 3 melhores jogadores diários receberão molduras e recompensas em moedas",
    theTop2:
      "Os 10 melhores jogadores semanais receberão molduras e recompensas em moedas",
    usersWho:
      "Os usuários que participam de jogos de evento todos os dias podem abrir uma bolsa da sorte no dia seguinte para receber uma quantidade aleatória de moedas. Quanto mais você gasta em jogos de evento, mais moedas você pode obter",
    behindPrevious: "Atrás do anterior",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "Contagem regressiva:",
    days: "dias",
    winOver: "Ganhar mais de",
    coinsfrom: "moedas de jogos em um único dia",
    earnOver: "Ganhar mais de",
    coinsWitdh: "com taxa de retorno de até",
    fromOneDay: "de um dia em",
    game: "Jogo",
    fromA: "de uma única aposta em",
    inthisWeek: "Nesta Semana",
    earnUp: "Ganhe até",
    inAsingle: "em um único dia",
    eventRules: "Regras do evento",
    participateIn:
      "Participe do jogo para resgatar uma bolsa da sorte maior amanhã",
    youDid:
      "Você não recebeu a recompensa em moedas. Participe do jogo e você pode continuar a resgatar a bolsa da sorte amanhã",
    participateIn2:
      "Participe do jogo e você pode continuar a resgatar a bolsa da sorte amanhã",
    topDaily: "Melhor Vencedor Diário de Moedas",
    topPayout: "Melhor Vencedor da Taxa de Pagamento",
    topCoins: "Melhor Vencedor de Moedas em Uma Rodada Semanal",
    topPayout2: "Melhor Vencedor da Taxa de Pagamento em Uma Rodada Semanal",
    topWeekly: "Melhor Vencedor Semanal de Moedas",
    historicalTop: "Melhor Vencedor Histórico de Moedas em Um Dia",
    historicalTop2: "Melhor Vencedor Histórico da Taxa de Pagamento em Um Dia",
    historicalTop3: "Melhor Vencedor Histórico de Moedas em Uma Rodada",
    historicalTop4:
      "Melhor Vencedor Histórico da Taxa de Pagamento em Uma Rodada",
    historicalTop5: "Melhor Vencedor Histórico de Moedas em Uma Semana",
    gameReward: "Recompensa do jogo",
    usersSpending2:
      "Os gastos dos usuários em jogos de evento contarão para sua pontuação de classificação",
    theTop3:
      "Os 3 melhores jogadores diários receberão molduras e recompensas em moedas",
    theTop4:
      "Os 10 melhores jogadores semanais receberão molduras e recompensas em moedas",
    usersWho2:
      "Os usuários que participam de jogos de evento todos os dias podem abrir uma bolsa da sorte no dia seguinte para receber uma quantidade aleatória de moedas. Quanto mais você gasta em jogos de evento, mais moedas você pode obter",
    coins: "Moedas",
    flameRider: "Cavaleiro da Chama",
    sportCar: "Carro Esportivo",
    captainMeow: "Capitão Miau",
    profileFrame: "Moldura de Perfil",
  },
  gold: {
    coinsDetail: "Detalhe das Moedas",
    coinBalance: "Saldo de Moedas",
    all: "ALL",
    sendGifts: "Enviar Presentes",
    purchaseItems: "Comprar Itens",
    games: "Jogos",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "Recompensas de Atividade",
  },
  integral: {
    all: "All",
    cashOut: "Sacar",
    transfer: "Transfer",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "Tempo de Saque",
    pointsAmount: "Quantidade de Pontos",
    depositAmount: "Valor do Depósito",
    coinsAmount: "Quantidade de Moedas",
    transferTo: "Transferir para",
    normal: "Normal",
    pending: "Pendente",
    success: "Success",
    failed: "Falhou",
    points: "Points",
    pointsBalance: "Saldo de Pontos",
    frozenPoints: "Pontos Congelados",
    details: "Detalhes",
    exchange: "Exchange",
    currencyType: "Tipo de Moeda",
    paymentMethod: "Payment method",
    pointsAmount2: "Quantidade de pontos para saque",
    enterA: "Insira um múltiplo de 100.000 (mínimo 200.000)",
    enterA2: "Insira um múltiplo de 100000",
    accountInformation: "Informações da conta",
    withdraw: "Sacar",
    amount: "Quantidade",
    exchangeRate: "Taxa de câmbio",
    exchangePoints: "Pontos de troca",
    enterUserId: "Insira o ID do usuário",
    check: "Check",
    fee: "Taxa",
    theAgency: "A agência receberá",
    transferFee:
      "Taxa de transferência: 2%. Transferência mínima ≥ 100.000 pontos.",
    clickTransfer:
      "Clique no botão de transferência para transferir os pontos correspondentes para seus agentes",
    afterThe2:
      "Após a transferência ser concluída, não pode ser cancelada ou retirada",
    transferPoints: "Pontos de transferência",
    recommendedMethod: "Método recomendado",
    lowerFees: "Taxas mais baixas e revisadas em 24 horas",
    paymentPassword: "Senha de pagamento não definida",
    cashOut2:
      "Saques e Trocas exigem verificação de senha de pagamento. Por favor, defina sua senha de pagamento primeiro.",
    cancel: "Cancel",
    goTo: "Ir para Configurações",
    youHave:
      "Você atingiu 5 tentativas malsucedidas. Mais uma tentativa malsucedida resultará no congelamento da sua conta. Se esqueceu sua senha, redefina-a.",
    inputIncorrect:
      "Inseriu a senha incorreta várias vezes. Sua conta foi congelada, tente novamente após",
    verify: "verificar",
    gotIt: "Got it",
    pointsInfo: "Informações de pontos",
    whenA:
      "Quando um usuário envia presentes para você usando Moedas recarregadas via Google, os pontos que você recebe serão congelados por 7 dias antes de se tornarem disponíveis. Se o usuário solicitar um reembolso, esses pontos serão deduzidos. Por favor, siga as regras da plataforma e evite quaisquer violações.",
    frozenPointsAre:
      "Pontos congelados estão incluídos no saldo total de pontos",
    theUser2: "O usuário foi colocado na lista negra",
    successfulWithdrawal: "Saque bem-sucedido",
    withdrawalAmount: "Valor do saque",
    theFunds: "Os fundos chegarão em até 24 horas",
    pleaseEnter2: "Por favor, insira a senha",
    passwordIncorrect: "Senha incorreta",
    theAmount4: "O valor deve ser um múltiplo de 100000",
    pleaseEnter3: "Por favor, insira o ID do usuário",
    pleaseEnter4: "Por favor, insira o ID de usuário correto",
    pleaseEnter5: "Por favor, insira o valor",
    minimumTransfer: "Transferência mínima ≥ 100.000 pontos",
    pleaseSelect3: "Por favor, selecione o método",
    minimum: "minimum",
    theAmount5: "O valor deve ser menor que",
    illegalInput: "Entrada ilegal",
    pleaseEnter6: "Por favor, insira as informações da conta",
  },
  invite: {
    inviteGame: "Convidar usuário do jogo",
    currentRebate: "Rebate atual",
    need: "precisa",
    toProgress: "para progredir para o próximo nível",
    gameReward: "Game Reward",
    referralData: "Dados de indicação",
    referralList: "Lista de indicação",
    date: "Date",
    gameBets: "Apostas do jogo",
    inviteRewards: "Recompensas de convite",
    viewMore: "Ver mais",
    inviteFriends: "Convidar amigos",
    myReward: "Minha recompensa",
    totalRewards: "Total de recompensas",
    dailyReward: "Recompensa diária",
    inviteRules: "Regras de convite",
    yourRebate:
      "Sua taxa de rebate depende das suas Apostas Válidas Totais nos últimos 30 dias",
    totalValid2:
      "Apostas Válidas Totais = Suas próprias apostas + As próprias apostas de cada nível dos seus usuários convidados",
    rebateFrom:
      "Rebate dos usuários convidados do Tier-1 = Suas próprias apostas × Sua taxa de rebate",
    rebateFrom2:
      "Rebate dos usuários convidados do Tier-2 = Suas próprias apostas × (Sua taxa de rebate - Taxa de rebate do Tier-1)",
    ifThe:
      "Se o usuário convidado do Tier-2 convidar um usuário do Tier-3, isso pode aumentar suas Apostas Válidas Totais, mas ele não pode obter um rebate do Tier-3.",
    example: "Exemplo",
    tier1:
      "Tier-1 convidado - Como calcular o rebate daqueles que são diretamente convidados por você?",
    asRebate:
      "Rebate de A de B, C e D = (Apostas próprias de B + Apostas próprias de C + Apostas próprias de D) × Taxa de rebate de A =",
    bsRebate:
      "Rebate de B de E e F = (Apostas próprias de E + Apostas próprias de F) × Taxa de rebate de B =",
    csRebate:
      "Rebate de C de G = Apostas próprias de G × Taxa de rebate de C =",
    tier2:
      "Tier-2 convidado - Como calcular o rebate daqueles que são indiretamente convidados por você?",
    asRebate2:
      "Rebate de A de E e F = (Taxa de rebate de A - Taxa de rebate de B) × (Apostas próprias de E + Apostas próprias de F) =",
    asRebate3:
      "Rebate de A de G = (Taxa de rebate de A - Taxa de rebate de C) × Apostas próprias de G =",
    myInvitation: "Meu Convite",
    search: "Search",
    invitationTime: "Hora do convite",
    inviteHost: "Invite Host",
    inviteA: "Convidar um anfitrião, cada um até",
    todayRewards: "Recompensas de hoje",
    rewardDetail: "Detalhe da recompensa",
    creatorRewards: "Carteira de Recompensas do Criador",
    collect: "Coletar",
    invitationDate: "Data do convite",
    hostPolicy: "Política do anfitrião",
    halaReserves2:
      "Hala reserva-se o direito de interpretação final das políticas acima.",
  },
  listContribution: {
    contributiont: "Contribuição",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "Ontem",
    game: "Game",
    gift: "Presente",
    hostEarnings: "Ganhos do anfitrião",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3:
      "Hala reserva-se o direito de interpretação final das políticas acima",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "Mudar de conta",
    countryRegion: "País/Região",
    officialAgency: "Recarga de agência oficial",
    ttOff: "20% de desconto",
    totalAmount: "Valor total",
    purchase: "Comprar",
    pleaseComfirm: "por favor, confirme o ID do usuário",
    pleaseInput8: "Por favor, insira o ID do usuário",
    onlineService: "Serviço online",
    dealOf: "Negócio dos últimos 30 dias",
    recent30Day2: "Vendas de moedas dos últimos 30 dias",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2:
      "Seu país atualmente não tem vendedores de moedas disponíveis",
    pleaseContact2: "Por favor, entre em contato com o suporte ao cliente.",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest:
      "O progresso do baú do tesouro é aumentado dando presentes na sala",
    whenThe:
      "Quando a barra de progresso da chave do baú estiver cheia, o baú do tesouro será aberto",
    afterThe3:
      ".Depois que os baús do tesouro de nível 3 e 4 atenderem aos requisitos, eles serão bloqueados por 1 minuto e então abertos automaticamente",
    everyoneIn:
      "Todos na sala têm a chance de ganhar as recompensas no baú do tesouro.",
    onceThe:
      "Após a abertura do baú do tesouro, pode levar alguns minutos para o sistema creditar a recompensa em sua conta. As moedas de ouro serão adicionadas ao seu saldo e o traje ao seu inventário.",
    theHigher:
      "Quanto maior o nível do baú do tesouro, maiores serão as recompensas nele contidas.",
    ifYou2:
      "Se você for selecionado como VIP com um nível VIP inferior ao seu nível atual, o novo nível VIP não entrará em vigor.",
    theProgress:
      "A barra de progresso da chave do baú será reiniciada às 00:00 (UTC+5:30) todos os dias.",
  },
  share: {
    joinHala:
      "Junte-se à Hala para desbloquear diversas oportunidades de ganhos e desfrutar de benefícios e recompensas personalizados para agências.",
    downloadTo: "Faça o download para se tornar um parceiro.",
    joinHala2:
      "Participe de jogos divertidos com Hala e concorra a prêmios incríveis.",
    downloadAnd: "Baixe agora e comece a ganhar!",
    joinHala3:
      "Junte-se à Hala e comece sua jornada como anfitrião(ã). Ganhe bônus diários de até US$ 36!",
    inviteYou: "Convidamos você a se juntar à Agência.",
    downloadNow: "Baixe agora para começar a hospedar",
    comeWith: "Venha comigo para a sala de bate-papo em Hala.",
    enthusiastsFrom:
      "Entusiastas de todo o mundo se reúnem para compartilhar...",
    igniteEndless: "Desperte a diversão sem fim",
    download: "Download",
    halaLive: "Hala Live",
    showMe: "Mostre-me o mundo feliz",
    saySomething: "Dizer algo...",
    downloadHala: "Baixe o aplicativo Hala",
  },
  starHost: {
    starHost: "Apresentador principal",
    level2: "Nível {level} mantido por {days} dias",
    currentSalary: "Salário atual",
    points: "Points",
    likes: "Curtidas",
    stillNeed: "Still need",
    done: "Feito",
    numberOf2: "Número de doadores",
    gifters: "Presenteadores",
    gcoinGifts: "Presentes Gcoin",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "min",
    completeAll: "Conclua todas as seguintes tarefas para fazer o upgrade.",
    follower: "Seguidor",
    numberOf3: "Número de doadores",
    daysAt: "Dias no nível {level}",
    giftCollection: "Coleção de Presentes",
    gift: "Gift",
    date: "Date",
    expectedSalary: "Salário esperado",
    gcoin: "Gcoin",
    status: "Status",
    levelReached: " Nível alcançado",
    notAchieved: "Não alcançado",
    starHost2: "Regras do anfitrião principal",
    eachStar: "Cada Anfitrião Estrela tem um período de teste de 3 dias.",
    theyWill:
      "Eles só se tornarão Anfitriões Estrelas oficiais se atenderem aos padrões de excelência exigidos durante os 3 dias.",
    thoseWho:
      "Aqueles que não atingirem as metas diárias do nível A serão demitidos.",
    firedHosts:
      "Apresentadores demitidos não podem receber o salário base de Apresentador Estrela.",
    starHost3:
      "O salário base do Star Host é pago semanalmente, todas as segundas-feiras.",
    ifA:
      "Se um Anfitrião Estrela não concluir as tarefas diárias, receberá apenas 50% do salário por hora.",
    selfGifting:
      "Presentear a si mesmo é estritamente proibido para todos os destinatários de presentes.",
    starHost4: "Recompensas de Anfitrião Estrela de Diferentes Níveis",
    level: "Level",
    dailyExtra: "Recompensas diárias de pontos extras",
    liveBroadcast: "Tempo de transmissão ao vivo necessário",
    starHost5: "Requisitos de anfitrião estelar para diferentes níveis",
    requirements: "Requisito(s)",
    yourApplication: "Sua solicitação foi aprovada oficialmente.",
    stayOn: "Permanecer no nível A por 7 dias",
    over1k: "Mais de 1.000 fãs",
    totalGifter: "Número total de doadores > 300",
    receiveAll: 'Receba todos os presentes da "Sorte"',
    everyLucky: "Cada número de presentes da sorte deve ser superior a 100.",
    stayOn2: "Permaneça no nível S por 10 dias.",
    over2k: "Mais de 2 mil fãs",
    totalGifter2: "Número total de doadores > 300",
    receiveAll2: 'Receba todos os presentes "imperdíveis"',
    stayOn3: "Permanecer no nível SS por 10 dias",
    over5k: "Mais de 5 mil fãs",
    totalGifter3: "Número total de doadores > 1000",
    receiveAll3: 'Receba todos os presentes "de luxo".',
    starHost6: "Tarefas diárias do apresentador principal",
    dailyAssessment: "(Sistema de Avaliação Diária): Interação / Presentes",
    gcionGifts: "Presentes Gcion",
    rulesTo: "Regras para degradar o nível do hospedeiro estelar",
    failTo: "Não atingir os padrões do nível atual por 3 dias consecutivos.",
    failingTo: "Não cumprir os padrões <span>3 vezes em uma semana",
    ifThe2:
      "Se o anfitrião que não cumprir a exigência diária for de nível A, ele/ela será demitido(a) diretamente, em vez de rebaixado(a). Após o rebaixamento, o anfitrião deverá atender aos padrões do nível original por 3 dias consecutivos para recuperar o nível.",
    involvementIn: "Envolvimento em violações graves ou incidentes negativos.",
    causingDamage:
      "Causar danos aos interesses da plataforma ou à imagem da marca.",
    applyFor: "Solicite a demissão por conta própria.",
    liveStreaming: "Requisitos para transmissão ao vivo",
    liveStream:
      "O conteúdo da transmissão ao vivo deve estar de acordo com o tipo designado pelo apresentador.",
    roomHosts:
      "Os anfitriões das salas estão proibidos de silenciar seus microfones por períodos prolongados durante as transmissões.",
    liveStreams:
      "As transmissões ao vivo devem ser realizadas utilizando uma sala com 9 microfones cada.",
    otherSeats:
      "Os demais assentos da sala não podem ser ocupados por usuários ou membros da plateia que silenciem seus microfones para fins de terceirização de tarefas.",
    discriminatoryInsulting:
      "Comentários discriminatórios, insultuosos ou ofensivos são estritamente proibidos na sala.",
  },
  starRoom: {
    afterCountdown:
      "Após a contagem regressiva diária, os 3 melhores quartos serão listados no Ranking de Quartos Estrelados.",
    top20Star:
      "Os 20 quartos mais bem avaliados receberão bônus generosos após esta semana.",
    countdown: "Countdown：",
    top3Daily:
      "Os 3 melhores quartos diários se qualificarão para participar dos quartos com estrelas semanais.",
    starRooms:
      "Os quartos com estrelas serão classificados no último dia da semana. A classificação será feita de acordo com o fluxo total de moedas de cada quarto.",
    top20Weekly:
      "Os 20 proprietários de quartos com a melhor classificação semanal receberão as seguintes recompensas:",
    qualificationTo:
      "Requisitos para participar deste evento: Quaisquer violações ou comportamentos ilegais não serão permitidos na sala. Caso sejam constatados, a Hala desqualificará a sala e a removerá do ranking.",
    theRewards: "As recompensas serão enviadas todas as segundas-feiras.",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "Convide os anfitriões",
    pointsMax: "5.000 pontos no máximo por dia",
    firstRecharge: "Usuários da primeira recarga",
    get20: "Ganhe $20 grátis",
    oneInvite:
      "1. Convide os apresentadores para iniciar a transmissão ao vivo, assim que os apresentadores que você convidou terminarem.",
    aFinish: "a. Conclua a verificação facial na central de tarefas.",
    bCreate: "b. Criar seu próprio quarto",
    cLive: "c. Transmissão ao vivo no microfone por 3 horas em seu quarto.",
    dClaim: "d. Reivindique as recompensas ao vivo pela primeira vez.",
    youGet:
      "Você ganha pontos diariamente com base nos números de telefone válidos dos seus convidados. Você pode resgatar as recompensas no dia seguinte.",
    validHost: "Host válido",
    pointsReward: "Recompensa por Pontos",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "Meus anfitriões convidados",
    validHosts: "Anfitriões válidos hoje",
    pointsRewards: "Recompensas por Pontos",
    validHosts2: "Anfitriões válidos ontem:",
    claim: "Alegar",
    claimed: "Reivindicado",
    completedTime: "Tempo de conclusão",
    ifYour:
      "Se seus amigos completarem a primeira recarga, você receberá muitas recompensas (recargas offline também serão consideradas).",
    theMore:
      "Quanto maior for o valor da sua primeira recarga, mais moedas você ganhará, podendo chegar a US$ 20 por dia.",
    inviteesRecharge: "Convidados recarregam moedas",
    yourReward: "Suas Moedas de Recompensa",
    threeOnly:
      "3. Somente os usuários que forem convidados a recarregar dentro de 30 dias serão considerados usuários válidos para a primeira recarga.",
    seniorAnd:
      "Os vendedores seniores e padrão serão contabilizados somente quando recarregarem pelo aplicativo ou diretamente pelo site oficial (consulte seu administrador para obter informações sobre os métodos de pagamento). A primeira recarga será considerada válida para usuários que realizaram a recarga pela primeira vez.",
    myInvited2: "Meus usuários convidados",
    rechargeCoins: "Recarregue moedas",
    coinsRewards: "Recompensas em Moedas",
    firstRecharge2: "Moedas de primeira recarga Ontem:",
    firstRecharge3: "Moedas de primeira recarga",
    firstRecharge4: "Tempo da primeira recarga",
  },
  hostPolicy: {
    title: "Política do Host",
    section1Title: "Salário Base da Primeira Semana para Novos Hosts",
    requirement: "Requisito",
    newHostsDesc: "Novos hosts que se juntaram ao Hala na primeira semana",
    activeTime: "Tempo Ativo no Microfone",
    oneHour: "1 Hora",
    twoHour: "2 Horas",
    threeHour: "3 Horas",
    baseSalary: "Salário Base (Pontos)",
    incomeRequirement: "Requisito de Renda",
    none: "Nenhum",
    remarks: "Observações",
    remarksDesc:
      "Máximo 3 horas/dia. Máximo 7 dias. Recompensa máxima total de 35.000 pontos",
    note1:
      "A partir da data do registro do host, começa a contagem regressiva do período de validade do salário básico de 7 dias.",
    note2:
      "Os hosts que usarem múltiplas contas ou fizerem login com múltiplos IPs ou dispositivos serão desqualificados da recompensa de salário base.",
    note3:
      "Se a renda dos últimos 7 dias do host for superior a 150.000 pontos, ela receberá a Recompensa Horária de Host Comum em vez da Recompensa de Salário Base de Novo Host.",
    section2Title: "Recompensa Igual para Host Comum",
    level: "Nível",
    incomeRequirementShort: "Requisito de Renda",
    hourlyReward: "Recompensa Horária",
    maximumDailyHours: "Horas Máximas Diárias",
    section2Note1:
      "15 minutos consecutivos no microfone serão contados como tempo efetivo.",
    section2Note2:
      "Todas as recompensas são liquidadas em pontos e precisam ser resgatadas no sistema de tarefas.",
    section2Note3:
      "As recompensas da plataforma não serão contadas nos requisitos de pontos.",
    section2Note4:
      "Os pontos serão deduzidos uma vez que múltiplos IPs ou dispositivos sejam detectados.",
    section2Note5:
      "Os últimos 7 dias significam os últimos 6 dias+hoje, então suas recompensas horárias podem aumentar à medida que você atinge níveis de pontos mais altos em tempo hábil.",
    section2Note6:
      "As recompensas não alvo de nível L só serão válidas nos primeiros 7 dias após o registro. Após 7 dias, os hosts podem obter 500 pontos gratuitos todos os dias permanentemente.",
    section3Title: "Regulamentos do Host",
    regulation1: "É proibido que os hosts registrem múltiplas contas.",
    regulation2: "É proibido promover plataformas de terceiros.",
    regulation3: "Menores são estritamente proibidos.",
    regulation4:
      "Um host só pode ter um ID verificado. Apenas IDs verificados podem iniciar streaming ao vivo e sacar ganhos.",
    regulation5:
      "Qualquer ato de personificação de autenticação facial para iniciar streaming ao vivo ou sacar ganhos será permanentemente banido.",
    regulation6:
      "Fornecer ID a outros para streaming ao vivo resultará no ID sendo permanentemente banido pelo sistema.",
    regulation7:
      "Na sala de voz, os hosts devem cumprimentar ativamente os usuários que entram na sala.",
    regulation8:
      "A foto de capa da sala de voz deve usar uma foto real e compatível do host.",
    regulation9:
      "A plataforma Hala proíbe estritamente qualquer atividade fraudulenta. Quaisquer violações resultarão em suspensão permanente da conta.",
    footer:
      "A Hala reserva o direito de interpretação final das políticas acima.",
  },
  correspondingRevenue:
    "os requisitos de receita correspondentes forem atendidos. Todas as recompensas serão emitidas",
  within12: "dentro de 1-2 dias úteis após o término do evento",
};
